import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">이용약관</h1>
          
          <div className="prose max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제1조 (목적)</h2>
              <p className="text-gray-700 leading-relaxed">
                본 약관은 주식회사 비지리츠(이하 "회사")가 운영하는 EnglishPT 온라인 학습 플랫폼(이하 "서비스")의 이용과 관련하여 
                회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제2조 (정의)</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>"서비스"란 회사가 제공하는 온라인 강의 플랫폼 및 관련 서비스를 의미합니다.</li>
                <li>"이용자"란 본 약관에 따라 서비스를 이용하는 회원 및 비회원을 의미합니다.</li>
                <li>"회원"이란 서비스에 회원등록을 하고 서비스를 이용하는 자를 의미합니다.</li>
                <li>"강의"란 서비스를 통해 제공되는 모든 교육 콘텐츠를 의미합니다.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제3조 (약관의 효력 및 변경)</h2>
              <p className="text-gray-700 leading-relaxed">
                본 약관은 서비스를 이용하고자 하는 모든 이용자에 대하여 그 효력을 발생합니다. 
                회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 
                변경된 약관은 서비스 화면에 공지하거나 기타의 방법으로 회원에게 공지함으로써 효력을 발생합니다.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제4조 (회원가입)</h2>
              <p className="text-gray-700 leading-relaxed">
                이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로서 
                회원가입을 신청합니다. 회사는 제1항과 같이 회원가입을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 
                회원으로 등록합니다.
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li>가입신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
                <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
                <li>기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제5조 (서비스의 제공 및 변경)</h2>
              <p className="text-gray-700 leading-relaxed">
                회사는 다음과 같은 서비스를 제공합니다:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li>온라인 강의 콘텐츠 제공</li>
                <li>학습 진도 관리 및 통계 서비스</li>
                <li>강의 관련 자료 및 리소스 제공</li>
                <li>기타 회사가 추가 개발하거나 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제6조 (서비스의 중단)</h2>
              <p className="text-gray-700 leading-relaxed">
                회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 
                서비스의 제공을 일시적으로 중단할 수 있습니다. 회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 
                인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제7조 (회원의 의무)</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                회원은 다음 행위를 하여서는 안 됩니다:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>신청 또는 변경 시 허위내용의 등록</li>
                <li>타인의 정보 도용</li>
                <li>회사가 게시한 정보의 변경</li>
                <li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
                <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
                <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제8조 (지적재산권)</h2>
              <p className="text-gray-700 leading-relaxed">
                서비스에 게재된 모든 콘텐츠는 회사의 지적재산권 또는 제3자의 지적재산권으로 보호받습니다. 
                회원은 서비스를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 
                영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제9조 (면책조항)</h2>
              <p className="text-gray-700 leading-relaxed">
                회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 
                책임이 면제됩니다. 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">제10조 (준거법 및 관할법원)</h2>
              <p className="text-gray-700 leading-relaxed">
                본 약관의 해석 및 회사와 회원 간의 분쟁에 대하여는 대한민국 법을 적용하며, 
                본 분쟁으로 인하여 소송이 제기될 경우 서울중앙지방법원을 관할 법원으로 합니다.
              </p>
            </section>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                본 약관은 2025년 1월 1일부터 시행됩니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;

